<script lang="ts">
  import { AppState } from '../../etc/stores';
  import Typography from './Typography.svelte';

  type TypeStyle =
    | 'medium-regular'
    | 'medium-regular-semibold'
    | 'default-medium'
    | 'default-semibold'
    | 'default-regular'
    | 'default-link-regular';

  export let textAlign: string = 'left';
  export let color: string = $AppState.theme.colors.typography;
  export let type: TypeStyle = 'default-medium';
  export let component: string = 'p';
</script>

<Typography
  {component}
  class="twism-type-style-{type} {$$props.class || ''}"
  {color}
  {textAlign}
>
  <slot />
</Typography>

<style lang="scss">
  :global(.twism-type-style-medium-regular) {
    font-size: 14px;
    line-height: 16px;
    font-weight: 400;
  }

  :global(.twism-type-style-medium-regular-semibold) {
    font-size: 14px;
    line-height: 16px;
    font-weight: 600;
  }

  :global(.twism-type-style-default-medium) {
    font-size: 16px;
    line-height: 20px;
    font-weight: 500;
  }

  :global(.twism-type-style-default-semibold) {
    font-size: 16px;
    line-height: 20px;
    font-weight: 600;
  }

  :global(.twism-type-style-default-regular) {
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
  }

  :global(.twism-type-style-default-link-regular) {
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
    text-decoration: underline;
  }
</style>
